import { graphql } from '../../../graphql/generated';

export const AVAILABLE_BILLING_INFOS_QUERY = graphql(`
  query AvailableBillingInfos(
    $catalogParamId: ID!
    $selectedParameters: [SelectedParameterInput!]!
    $doctorId: ID!
    $requestIdForReorder: ID!
    $patientData: PatientDataInput!
  ) {
    availableBillingInfos(
      catalogParamId: $catalogParamId
      patientData: $patientData
      doctorId: $doctorId
      requestIdForReorder: $requestIdForReorder
      selectedParameters: $selectedParameters
    ) {
      billingInfos {
        additionalText
        billingType
        diagnoseId
        price
        specialRateId
        text
      }
      exceededPeriodicGroups {
        periodicGroup {
          id
          name
          period
          maxCount
        }
        lg
        paramsInGroup
      }
    }
  }
`);
